import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import styles from "../component/placeholder.module.scss";

export const BillingHistoryPage = () => {
	return (
		<UtilityPageLayout title="Billing History">
			<div className={styles.placeholderContainer}>
				<h2 className={styles.title}>Billing & Payment History</h2>
				<p className={styles.description}>
					View comprehensive billing records, payment transactions, invoices,
					and payment method information for customers.
				</p>
				<div className={styles.comingSoon}>Coming Soon</div>
			</div>
		</UtilityPageLayout>
	);
};
